import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import {BaseEmailPage} from "./BaseEmailPage";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: 'white',
    boxShadow: 24,
    p: 4,
    borderRadius: '20px',
    width: '600px',
    height: '646px'
};

export const EmailModal = (props) => {
    return (
        <Modal
            open={props.isOpen}
            onClose={() => props.setIsOpen(null)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >

            <Box
                style={{
                    ...style,
                }}
            >
                <BaseEmailPage {...props}/>
            </Box>
        </Modal>
    )
}